<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img"><img src="/assets/product/engine/4B15H/4B15H.jpg" alt=""></div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">4B15H 1.5L混合动力发动机</div>
                <div class="detail-banner-desc">
                    1.5L自然吸气混合动力发动机，匹配DHT变速器，适用于SUV、轿车车型。
                </div>
                
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4B15H/4B15H-1.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        强动力
                    </div>
                    <div class="detail-desc">
                        1.5L自然吸气混合动力发动机，匹配DHT变速器，适用于SUV、轿车车型；<br />
                        采用350bar高压缸内直喷技术，燃油直接喷入气缸油气混合更均匀，快速燃烧降低大负荷爆震倾向，提升发动机动力性。
                    </div>
                </div>
                <div class="detail-swiper-utils">
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            85kW
                        </div>
                        <div class="detail-swiper-d">
                            最大功率6000rpm
                        </div>
                    </div>
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            140N·m
                        </div>
                        <div class="detail-swiper-d">
                            最大扭矩(4000-4800)
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4B15H/4B15H-2.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        低油耗
                    </div>
                    <div class="detail-desc">
                        高压缩比+高EGR率系统，可减小发动机爆震倾向，增加点火提前角，降低发动机油耗，同时EGR系统采用催化器前取气方式，可将尾气中更多的CO等可燃气体导入燃烧室重新燃烧，进一步降低油耗。
                    </div>
                </div>
                <div class="detail-swiper-utils">
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            202g/kW·h
                        </div>
                        <div class="detail-swiper-d">
                            发动机最低燃油消耗率
                        </div>
                    </div>
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            41.5%
                        </div>
                        <div class="detail-swiper-d">
                            工程热效率
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4B15H/4B15H-3.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        低排放
                    </div>
                    <div class="detail-desc">
                        350bar缸内直喷系统，提高燃油喷射压力，优化混合气形成及燃烧过程，有效减少发动机在冷启动或高负荷时产生的未燃碳氢化合物（HC）、一氧化碳（CO）和氮氧化物（NOx）等有害气体排放；<br />
                        排气歧管集成在缸盖内可提高发动机暖机速度，缩短催化器起燃时间，降低/改善冷启动时的排放。
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">核心技术</div>
        <!-- <div class="detail-desc"></div> -->

        <div class="detail-four-list">
            <div class="detail-four-item">
                <div class="img-box"><img src="/assets/product/engine/4B15H/4B15H-4.jpg" alt=""></div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">大包角阿特金森循环</div>
                <div class="detail-four-desc">
                    为平衡功率油耗需求，采用230°CA大进气包角，配合VVT及1.28大程径比设计，有效压缩比可在16到10.9之间进行调节：降低爆震倾向，提升膨胀比进而降低油耗。
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">电子水泵+双节温器冷却控制系统</div>
                <div class="detail-four-desc">
                    基于整车运行工况，对爆震强度不同区域进行划分， 精确控制水泵流量及节温器开闭组合，对不同区域实施了不同的水温控制策略，既抑制了高负荷区爆震的产生，同时还满足了油耗区对水温的需求。
                </div>
            </div>
            <div class="detail-four-item">
                <div class="img-box"><img src="/assets/product/engine/4B15H/4B15H-5.jpg" alt=""></div>
            </div>
        </div>



    </div>
    <div class="detail-box">
        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4B15H/4B15H-6.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        漩涡式进气歧管
                    </div>
                    <div class="detail-desc">
                        进气歧管设计有漩涡式结构，EGR废气由切向涡旋式通道进入进气歧管，并从非等径出气口进入节气门后的稳压腔，经新鲜空气高速垂直冲击，将其打散，形成均匀的混合气，进入各缸，提升各缸的EGR率一致性及燃烧稳定性。
                    </div>
                </div>
            </div>
        </div>

    </div>


    <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
    nextTick(() => {
        const swiperContainers = document.querySelectorAll('.swiper-container');

        swiperContainers.forEach((container, index) => {
            const containerKey = `swiper_${index}`;
            container.dataset.swiperKey = containerKey;
            const swiperInstance = new Swiper(container, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 300,
                preventClicks: true,
                effect: 'fade',
            });
            swiperInstances.value[containerKey] = swiperInstance;
        });

        bindTabClickEvent();
    });
});
function bindTabClickEvent() {
    const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

    allSwiperLists.forEach((swiperList) => {
        const tabItems = swiperList.querySelectorAll('.detail-tab-item');
        const targetSwiperContainer = swiperList.querySelector('.swiper-container');

        if (!tabItems.length || !targetSwiperContainer) return;

        const containerKey = targetSwiperContainer.dataset.swiperKey;
        const targetSwiper = swiperInstances.value[containerKey];
        if (!targetSwiper) return;

        const handleTabAction = (tabItem, localTabIndex) => {
            tabItems.forEach(item => item.classList.remove('active'));
            tabItem.classList.add('active');
            targetSwiper.slideTo(localTabIndex, 300, true);
        };
        tabItems.forEach((tabItem, localTabIndex) => {
            const handleTabClickWrapper = () => {
                handleTabAction(tabItem, localTabIndex);
            };
            tabItem.removeEventListener('click', handleTabClickWrapper);
            tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
            tabItem.addEventListener('click', handleTabClickWrapper);
            tabItem.addEventListener('mouseenter', handleTabClickWrapper);
        });
    });
}

</script>

<script>
export const pageConfig = {
    title: '4B15H 1.5L混合动力发动机 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'engine/4B15H.html'
};

import { createApp } from 'vue';
import App from './4B15H.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./4B15H.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>